import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import EmbeddedModal from 'components/modal/EmbeddedModal'
import ModalButton from 'components/modal/ModalButton'

const NeedInfoScreen = props => {
  return (
    <Div
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <EmbeddedModal
        actions={[
          <ModalButton
            key="pingback"
            testId="pingback"
            title="Yes, let's go."
            onClick={props.onActionClick}
          />
        ]}
      >
        You can only swipe through others{"'"} pictures if you share your age
        and location as well. Are you ready?
      </EmbeddedModal>
    </Div>
  )
}

NeedInfoScreen.propTypes = {
  onActionClick: PropTypes.func
}

NeedInfoScreen.defaultProps = {
  onActionClick: () => {}
}

export default NeedInfoScreen



// WEBPACK FOOTER //
// ./src/components/app/NeedInfoScreen.js